<template>
	<div class="a-usp">
		<div v-if="icon" class="a-usp__icon">
			<svg
				width="21"
				height="20"
				viewBox="0 0 21 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				aria-hidden="true"
		>
			<path d="M10.5 19.9999C13.1522 19.9999 15.6957 18.9463 17.5711 17.0709C19.4464 15.1956 20.5 12.652 20.5 9.99988C20.5 7.34771 19.4464 4.80417 17.5711 2.92881C15.6957 1.05345 13.1522 -0.00012207 10.5 -0.00012207C7.84784 -0.00012207 5.3043 1.05345 3.42893 2.92881C1.55357 4.80417 0.5 7.34771 0.5 9.99988C0.5 12.652 1.55357 15.1956 3.42893 17.0709C5.3043 18.9463 7.84784 19.9999 10.5 19.9999ZM14.9141 8.16394L9.91406 13.1639C9.54688 13.5311 8.95312 13.5311 8.58984 13.1639L6.08984 10.6639C5.72266 10.2968 5.72266 9.703 6.08984 9.33972C6.45703 8.97644 7.05078 8.97253 7.41406 9.33972L9.25 11.1757L13.5859 6.83582C13.9531 6.46863 14.5469 6.46863 14.9102 6.83582C15.2734 7.203 15.2773 7.79675 14.9102 8.16003L14.9141 8.16394Z" fill="#31A9E1" />
			</svg>
		</div>
		<span class="a-usp__title u-fs16">{{ label }}</span>
	</div>
</template>

<script setup>
const props = defineProps( {
	label: {
		type: String,
		default: '',
	},
	icon: {
		type: Boolean,
		default: true,
	},
} );
</script>


